///////COMPONENTS///////
import { put, select, takeLatest } from 'redux-saga/effects'
import ActionsTypes from '../../constants/ActionsTypes'
import {
	globalLoadingActionCreators,
	errorManagerActionCreators,
	distributionGroupRepositoryActionCreators,
	toastSuccessActionCreators,
} from '../actions'
import * as R from '../../constants/Endpoint'
import { API_TOKEN } from '../../config/AxiosConfig'
import { selectIdsUser } from '../selectors/user'

const postDistributionGroup = function* ({ payload }) {
	const bodyMsg = payload.filters
	const user = yield select(selectIdsUser)
	const apiCall = R.POST_DISTRIBUTION_GROUP(payload.queryParams)

	yield put(globalLoadingActionCreators.startLoading())

	try {
		const data = yield API_TOKEN(user.jwt).post(apiCall, bodyMsg)
		yield put(distributionGroupRepositoryActionCreators.postDistributionGroupSuccess(data.data))
	} catch (e) {
		yield put(errorManagerActionCreators.createError(e.response))

		yield put(distributionGroupRepositoryActionCreators.postDistributionGroupFailure(e.response))
	} finally {
		yield put(globalLoadingActionCreators.endLoading())
	}
}

const postActiveItem = function* ({ payload }) {
	const user = yield select(selectIdsUser)
	// Using back call for timeline instead of this, to trigger the correct events
	//const apiCall       = R.POST_ACTIVE_ITEM(payload.idItem);
	const id = payload.idItem
	const query = payload.query
	const apiCall = R.POST_LIFE_CYCLE_ACTION(id, query)
	const MsgParams = 'toast__itemReferential_activeItem'
	yield put(globalLoadingActionCreators.startLoading())

	try {
		const data = yield API_TOKEN(user.jwt).put(apiCall)

		yield put(distributionGroupRepositoryActionCreators.postActiveItemSuccess(data.data))
		yield put(toastSuccessActionCreators.hydrateToast(MsgParams))
	} catch (e) {
		yield put(errorManagerActionCreators.createError(e.response))

		yield put(distributionGroupRepositoryActionCreators.postActiveItemFailure(e.response))
	} finally {
		yield put(globalLoadingActionCreators.endLoading())
	}
}

const postDeleteItem = function* ({ payload }) {
	const id = payload.idItem
	const query = payload.query
	const user = yield select(selectIdsUser)
	// Using back call for timeline instead of this, to trigger the correct events
	//const apiCall       = R.POST_DELETE_ITEM(id);
	const apiCall = R.POST_LIFE_CYCLE_ACTION(id, query)
	const MsgParams = 'toast__itemReferential_deleteItem'
	yield put(globalLoadingActionCreators.startLoading())
	try {
		const data = yield API_TOKEN(user.jwt).put(apiCall)

		yield put(distributionGroupRepositoryActionCreators.postDeleteItemSuccess(data.data))

		yield put(toastSuccessActionCreators.hydrateToast(MsgParams))
	} catch (e) {
		yield put(errorManagerActionCreators.createError(e.response))

		yield put(distributionGroupRepositoryActionCreators.postDeleteItemFailure(e.response))
	} finally {
		yield put(globalLoadingActionCreators.endLoading())
	}
}

const getItemDetail = function* ({ payload }) {
	const user = yield select(selectIdsUser)
	const apiCall = R.GET_ITEM_DETAIL(payload.idItem)

	yield put(globalLoadingActionCreators.startLoading())

	try {
		const data = yield API_TOKEN(user.jwt).get(apiCall)

		yield put(distributionGroupRepositoryActionCreators.getItemDetailSuccess(data.data))
	} catch (e) {
		yield put(errorManagerActionCreators.createError(e.response))

		yield put(distributionGroupRepositoryActionCreators.getItemDetailFailure(e.response))
	} finally {
		yield put(globalLoadingActionCreators.endLoading())
	}
}

const postDeactivateItem = function* ({ payload }) {
	const id = payload.id
	const query = payload.query
	const user = yield select(selectIdsUser)
	const apiCall = R.POST_LIFE_CYCLE_ACTION(id, query)
	const MsgParams = 'toast__itemRef__timeline_action_deactivateNow_success'
	yield put(globalLoadingActionCreators.startLoading())
	try {
		const data = yield API_TOKEN(user.jwt).put(apiCall)

		yield put(distributionGroupRepositoryActionCreators.postDeactivateItemSuccess(data.data))

		yield put(toastSuccessActionCreators.hydrateToast(MsgParams))
	} catch (e) {
		yield put(errorManagerActionCreators.createError(e.response))

		yield put(distributionGroupRepositoryActionCreators.postDeactivateItemFailure(e.response))
	} finally {
		yield put(globalLoadingActionCreators.endLoading())
	}
}

const sagas = function* () {
	yield takeLatest(ActionsTypes.POST_DISTRIBUTION_GROUP, postDistributionGroup)
	yield takeLatest(ActionsTypes.POST_ACTIVE_ITEM, postActiveItem)
	yield takeLatest(ActionsTypes.POST_DELETE_ITEM, postDeleteItem)
	yield takeLatest(ActionsTypes.GET_ITEM_DETAIL, getItemDetail)
	yield takeLatest(ActionsTypes.POST_DEACTIVATE_REF_ITEM, postDeactivateItem)
}

export default sagas
